import { ComponentBase } from "../_ComponentBase";
import { SalaryDateKindController } from "../../controllers";

/**
 * Renders a Salary Date Kind selection -button for the Calculation or Payroll
 * @example
 * ```html
 * <salaxy-salary-date-kind-button disabled="$ctrl.isReadOnly" model="$ctrl.current.workflow"></salaxy-salary-date-kind-button>
 * ```
 */
export class SalaryDateKindButton extends ComponentBase {

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = {

      /**
       * The current object containing salaryDateKind -field: Either Calculation or PayrollDetails.
       */
      model: "<",

      /** Expression for ng-disabled of the input. */
      disabled: "<",

      /**
       * Additional class / classes for button. Can also be used to override default btn-primary class styles.
       * (i.e. <salaxy-pay-button button-class="btn-lg uppercase btn-success">)
       */
      buttonClass: "@",

      /** Called when the salary date kind has been changed. */
      onSalaryDateKindChange: "&",
    };

    /**
     * Uses the SalaryDateKindController
     */
    public controller = SalaryDateKindController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/calc/SalaryDateKindButton.html";
}
